<template>
  <div class="accordion">
    <h4 class="title" @click="handleClick()">
      <i class="icon yule-icon-chevron-down" v-if="active"></i>
      <i class="icon yule-icon-chevron-right" v-else></i>
      {{ $t(title) }}
    </h4>
    <div class="content" v-if="active">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/*
  This component is an expandable accordion that can contain another Vue component.
  It's used like this:

  <accordion :defaultActive="true" :overwriteActive="accordionOneActive" title="ui.project_wizard.step2-invite-users" @click="accordionClick()">
    <component :is="accordionOne"></component>
  </accordion>
  <accordion :overwriteActive="accordionTwoActive" title="ui.project_wizard.step2-assign-users" @click="accordionClick()">
    <component :is="accordionTwo" v-bind="objectTwoProps"></component>
  </accordion>
*/

export default {
  props: {
    defaultActive: {
      type: Boolean
    },
    overwriteActive: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      active: false
    }
  },
  watch: {
    overwriteActive() {
      this.active = this.overwriteActive
    }
  },
  mounted() {
    if (this.defaultActive) {
      this.active = this.defaultActive
    }
  },
  methods: {
    handleClick() {
      this.active = !this.active
      this.$emit('click')
    }
  }
}
</script>
<style scoped>
.title {
  user-select: none;
  cursor: pointer;
  margin: 0;
  margin-bottom: 0.5em;
}
.accordion {
  margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// Accordion.vue?99c7dfe8